//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      groupValues: [],
      template: {},
      templateViews: []
    };
  },
  computed: {
    groupSpecs: function groupSpecs() {
      var _this = this;

      return this.groupValues.map(function (group, groupIndex) {
        var viewSpecs = _this.processTemplate(_this.mapFieldProperties(group), groupIndex, function (viewSpec, name, properties) {
          // Always reattach the data model to avoid losing entered data.
          return Object.assign({}, viewSpec, properties, {
            name: name,
            value: _this.$data._fieldModels[name]
          });
        });

        return Object.assign({}, _this.template, {
          childViews: viewSpecs
        });
      });
    }
  },
  methods: {
    $ready: function $ready() {
      var _this2 = this;

      // this.groupValues = this.spec.value;
      this.groupValues = this.spec.groupFieldProperties;
      this.template = this.spec.template;
      this.templateViews = this.template.childViews || [];
      this.groupValues.forEach(function (group, groupIndex) {
        _this2.processTemplate(_this2.mapFieldProperties(group), groupIndex, function (viewSpec, fullName, properties) {
          // this.$data._fieldModels[name] = group[viewSpec.name];
          _this2.$data._fieldModels[fullName] = properties.value;
        });
      });
    },
    mapFieldProperties: function mapFieldProperties(group) {
      var fieldProperties = {};
      group.forEach(function (field) {
        fieldProperties[field.name] = field;
      });
      return fieldProperties;
    },
    processTemplate: function processTemplate(properties, groupIndex, process) {
      var _this3 = this;

      return this.templateViews.map(function (viewSpec) {
        if (Utils.type.isString(viewSpec.name)) {
          // Process only if it is a field
          var fullName = "".concat(_this3.spec.name, "[").concat(groupIndex, "][").concat(viewSpec.name, "]");
          return process(viewSpec, fullName, properties[viewSpec.name] || {});
        }

        return viewSpec;
      });
    },
    addGroup: function addGroup() {
      this.groupValues.push([{}]);
    },
    removeGroup: function removeGroup(index) {
      var _this4 = this;

      Utils.launch.sheet.confirm({}, function () {
        // Don't delete the group in order to maintain consistent indexes between model and view.
        _this4.$set(_this4.groupValues[index], "_destroy", 1);
      }, this);
    },
    isDeleted: function isDeleted(index) {
      return this.groupValues[index]._destroy;
    }
  }
};